import React from "react";
import useClock from "../../hooks/useClock";

type QueueHeaderProps = {
  eyebrow: string;
  title: string;
  /** Ligne sous le titre (compteurs). */
  subtitle: React.ReactNode;
  /** Bouton(s) à droite, après l'heure. */
  actions?: React.ReactNode;
};

/**
 * En-tête des écrans de liste d'attente, aligné sur la page Patients :
 * sur-titre, titre, compteurs, pastille « Temps réel » et heure courante.
 */
const QueueHeader: React.FC<QueueHeaderProps> = ({ eyebrow, title, subtitle, actions }) => {
  const clock = useClock();
  return (
    <header className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className="text-[11px] uppercase tracking-[0.32em] text-emerald-700 font-semibold">{eyebrow}</p>
        <h1 className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
        <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <span className="inline-flex items-center gap-2 rounded-full border border-emerald-100 bg-emerald-50/80 px-3 py-1 text-[11px] font-medium text-emerald-700">
          <span className="relative flex h-1.5 w-1.5">
            <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-500" />
          </span>
          Temps réel
        </span>
        <span className="inline-flex items-center gap-1.5 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 tabular-nums">
          <i className="bx bx-time-five text-base text-slate-400" aria-hidden />
          {clock}
        </span>
        {actions}
      </div>
    </header>
  );
};

export default QueueHeader;
